const getAuthToken = () => {
  try {
    const tokenData = sessionStorage.getItem("authToken") || localStorage.getItem("authToken");
    if (!tokenData) return null;
    try {
      const parsed = JSON.parse(tokenData);
      return parsed.access || parsed.access_token || parsed.token;
    } catch {
      // Token is a raw JWT string, not JSON
      return tokenData;
    }
  } catch (e) {
    console.error("Error retrieving auth token:", e);
  }
  return null;
};

export const getSectorDirectives = async (tokenParam?: string) => {
    const token = tokenParam || getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}accuracy_government_sector/directive-accuracy/requests/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Legal Advisory request");
    }
    return response.json();
};
export const getSectorDirectivesByStakeholder = async (stakeholder_id: string, tokenParam?: string) => {
    const token = tokenParam || getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}accuracy_government_sector/directive-accuracy/requests/by-stakeholder/?stakeholder_id=${stakeholder_id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Legal Advisory request");
    }
    return response.json();
};
export const getSectorDirective = async (id: string, tokenParam?: string) => {
    const token = tokenParam || getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}accuracy_government_sector/directive-accuracy/requests/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Legal Advisory request");
    }
    return response.json();
};

export const createSectorDirective = async (data: FormData, tokenParam?: string) => {
    const token = tokenParam || getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}accuracy_government_sector/directive-accuracy/requests/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const updateSectorDirective = async (id: string, data: FormData, tokenParam?: string) => {
    const token = tokenParam || getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}accuracy_government_sector/directive-accuracy/requests/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "PATCH",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to update Legal Advisory request");
    }
    return response.json();
};


export const createSectorDirectiveRespondbackFeedback = async (data: FormData, tokenParam?: string) => {
    const token = tokenParam || getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}accuracy_government_sector/directive-accuracy/respond-back-feedbacks/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};


export const createSectorDirectiveRemark = async (data: FormData, tokenParam?: string) => {
    const token = tokenParam || getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}accuracy_government_sector/directive-accuracy/remarks/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const createSectorDirectiveProsecutorAssignment = async (data: FormData, tokenParam?: string) => {
    const token = tokenParam || getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}accuracy_government_sector/directive-accuracy/prosecutor-assignments/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const updateSectorDirectiveProsecutorAssignment = async (id: string, data: FormData, tokenParam?: string) => {
    const token = tokenParam || getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}accuracy_government_sector/directive-accuracy/prosecutor-assignments/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "PATCH",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const deleteSectorDirectiveProsecutorAssignment = async (id: string, tokenParam?: string) => {
    const token = tokenParam || getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}accuracy_government_sector/directive-accuracy/prosecutor-assignments/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "DELETE",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
};

export const createSectorDirectiveAdditionalInfo = async (data: FormData, tokenParam?: string) => {
    const token = tokenParam || getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}accuracy_government_sector/directive-accuracy/additional-infos/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const updateSectorDirectiveAdditionalInfoRequest = async (id: string, data: FormData, tokenParam?: string) => {
    const token = tokenParam || getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}accuracy_government_sector/directive-accuracy/additional-infos/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "PATCH",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const createSectorDirectiveFeedback = async (data: FormData, tokenParam?: string) => {
    const token = tokenParam || getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}accuracy_government_sector/directive-accuracy/feedbacks/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

